/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreateGroupSale,
    AdminCreateGroupSaleFromJSON,
    AdminCreateGroupSaleToJSON,
    AdminGroupSaleDetail,
    AdminGroupSaleDetailFromJSON,
    AdminGroupSaleDetailToJSON,
    AdminGroupSaleListResponse,
    AdminGroupSaleListResponseFromJSON,
    AdminGroupSaleListResponseToJSON,
    AdminUpdateGroupSale,
    AdminUpdateGroupSaleFromJSON,
    AdminUpdateGroupSaleToJSON,
} from '../models';

export interface GroupSaleApiAdminGroupSaleCreateRequest {
    params: AdminCreateGroupSale;
}

export interface GroupSaleApiAdminGroupSaleDetailRequest {
    id: string;
}

export interface GroupSaleApiAdminGroupSaleUpdateRequest {
    id: string;
    params: AdminUpdateGroupSale;
}

export function createAdminGroupSaleCreatePath(): string {
    return `/admin/group-sale/create`;
}
export function createAdminGroupSaleCreateFullPath(): string {
    return runtime.BASE_PATH + `/admin/group-sale/create`;
}
export function createAdminGroupSaleDetailPath(id: string): string {
    return `/admin/group-sale/detail/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGroupSaleDetailFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/group-sale/detail/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGroupSaleListPath(): string {
    return `/admin/group-sale/list`;
}
export function createAdminGroupSaleListFullPath(): string {
    return runtime.BASE_PATH + `/admin/group-sale/list`;
}
export function createAdminGroupSaleUpdatePath(id: string): string {
    return `/admin/group-sale/update/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGroupSaleUpdateFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/group-sale/update/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}

/**
 *
 */
export class GroupSaleApi extends runtime.BaseAPI {
    /**
     * Create a new group sale
     * Create group sale
     */
    async adminGroupSaleCreate(
        requestParameters: GroupSaleApiAdminGroupSaleCreateRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<string>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminGroupSaleCreate.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGroupSaleCreatePath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminCreateGroupSaleToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response ? undefined : (new runtime.TextApiResponse(response) as any)
        );
    }
    /**
     * Get details of a group sale by ID
     * Get group sale details
     */
    async adminGroupSaleDetail(
        requestParameters: GroupSaleApiAdminGroupSaleDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminGroupSaleDetail>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminGroupSaleDetail.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGroupSaleDetailPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminGroupSaleDetailFromJSON(jsonValue))
        );
    }
    /**
     * Get a list of group sales
     * List group sales
     */
    async adminGroupSaleList(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminGroupSaleListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGroupSaleListPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminGroupSaleListResponseFromJSON(jsonValue))
        );
    }
    /**
     * Update an existing group sale
     * Update group sale
     */
    async adminGroupSaleUpdate(
        requestParameters: GroupSaleApiAdminGroupSaleUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminGroupSaleUpdate.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminGroupSaleUpdate.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGroupSaleUpdatePath(String(requestParameters?.id)),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminUpdateGroupSaleToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}
